var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg404Cord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 388.476,
    height: 112.729,
    viewBox: "0 0 388.476 112.729",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41245",
    "data-name": "Group 41245",
    transform: "translate(0.499 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M1478.418-12762.111s2.319,29.693,41.129,10.4,99.992-25.312,99.992-25.312v-14.945h-33.007l-2.489-9.169,37.366-43.993h12.428V-12804h8.734v12.037h-8.734v14.945H1672.4c10.2,0-16.46-4.513-16.214-33.2,0-19.415,11.361-35.06,25.685-35.06s26.146,13.58,26.146,35.71c.015,27.31-27.745,32.549-14.076,32.549h61.651v-14.945h-32.5l-2.534-9.169,36.916-43.993h11.972V-12804h9.344v12.037h-9.344v14.945s26.187,3.918,40.2-8.372c10.59-9.288,7.375-17.419,21.355-22.071s32.2-4.851,34.564,3.461-6.787,12.669-25.1,29.782-19.445,31.172-48.16,38.667-66.7-8.687-66.7-8.687",
    transform: "translate(-1478.418 12845.281)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M1641.246-12820.231l-17.617,19.936h17.617Z",
    transform: "translate(-1500.22 12841.878)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    d: "M1641.246-12820.231l-17.617,19.936h17.617Z",
    transform: "translate(-1363.689 12841.878)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    transform: "translate(188.931 13.447)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.683,
    cy: 21.264,
    rx: 14.683,
    ry: 21.264,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.683,
    cy: 21.264,
    rx: 14.183,
    ry: 20.764,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M2.592,0C19.578,0,19.655,10.4,19.655,10.4S19.578,20.739,2.592,20.739A2.592,2.592,0,0,1,0,18.147V2.592A2.592,2.592,0,0,1,2.592,0Z",
    transform: "translate(227.102 90.975)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1477",
    "data-name": "Rectangle 1477",
    width: 10.369,
    height: 3.456,
    rx: 1.728,
    transform: "translate(221.054 96.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1478",
    "data-name": "Rectangle 1478",
    width: 10.369,
    height: 3.456,
    rx: 1.728,
    transform: "translate(221.054 103.073)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg404Cord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/404cord.c0ee7dce617a987ca474effd1dc0f364.svg";